<section class="page__title p-relative d-flex align-items-center" [style.background-image]="'url('+bg_img+')'">
  <div class="container">
      <div class="row">
          <div class="col-xl-12">
              <div class="page__title-inner text-center">
                  <h1>{{title}}</h1>
                  <div class="page__title-breadcrumb">
                      <nav aria-label="breadcrumb">
                      <ol class="breadcrumb justify-content-center">
                          <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                          <li class="breadcrumb-item active" aria-current="page">{{subtitle}}</li>
                      </ol>
                      </nav>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
